import { useChatbotFlow } from '../../../chatbot.provider'
import { MedAlertSection } from '../med-alert-section.component'
import { ActionDashboardSection } from '../dashboard-section.component'

interface BooleanCardProps {
  label: string
  conditionKey: 'yes' | 'no'
}

export function BooleanCard({ label, conditionKey }: BooleanCardProps) {
  const { updateBooleanConditionAction } = useChatbotFlow()

  return (
    <div className="c-border c-border-gray-400 c-rounded-lg c-p-2 c-bg-white">
      <h4 className="c-text-sm c-font-semibold c-text-gray-900 c-mb-2">{label}</h4>

      <div className="c-flex c-gap-2 c-flex-wrap">
        <MedAlertSection
          actionPath={`variable.condition.${conditionKey}`}
          onUpdate={(action) => updateBooleanConditionAction(conditionKey, action)}
          responseContext={conditionKey}
        />

        <ActionDashboardSection
          actionPath={`variable.condition.${conditionKey}`}
          onUpdate={(action) => updateBooleanConditionAction(conditionKey, action)}
        />
      </div>
    </div>
  )
}
